import { render, staticRenderFns } from "./PhotoCounting.vue?vue&type=template&id=e021180e&scoped=true"
import script from "./PhotoCounting.vue?vue&type=script&lang=js"
export * from "./PhotoCounting.vue?vue&type=script&lang=js"
import style0 from "./PhotoCounting.vue?vue&type=style&index=0&id=e021180e&prod&scoped=true&lang=css"
import style1 from "./PhotoCounting.vue?vue&type=style&index=1&id=e021180e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e021180e",
  null
  
)

export default component.exports